<template>
  <div>
    <moneyInput label="金额" placeholder="金额" v-model="data[0].Money" />
    <van-cell-group>
      <fromSelect
        label="付款方式"
        v-model="data[0].AccountItemId"
        :required="true"
        :columns="payItems"
        @change="changeItem"
      />

      <van-field v-model="data[0].TargetName" label="客户会员" readonly />
      <fromSelect
        v-if="isSelectRoom"
        label="所属房号"
        v-model="roomId"
        textKey="RoomNo"
        valueKey="RoomId"
        :columns="selectRoomArr"
      />
      <van-field
        v-model="data[0].BillNo"
        label="单据编号"
        placeholder="请输入单据编号"
        clearable
      />
      <van-field
        v-model="data[0].Remark"
        rows="1"
        autosize
        type="textarea"
        label="备注信息"
        placeholder="请输入备注信息"
        clearable
      />
    </van-cell-group>
    <div class="submit">
      <van-button type="info" round size="large" @click="onSubmit">
        确认
      </van-button>
    </div>
  </div>
</template>

<script>
import moneyInput from "../../components/moneyInput";
import fromSelect from "../../components/form-select";
import selectMember from "@/components/select-member/function.js";
import MemberPasswordVerify from "@/components/member-password-verify/function.js";
import selectUser from "@/components/select-user/function.js";
import { getSelectData } from "../../api/common";
import { Field, Cell, CellGroup, Button, Notify } from "vant";
export default {
  name: "OrderPay",
  components: {
    moneyInput,
    fromSelect,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
  },
  props: {
    money: {
      type: String,
      default() {
        return "";
      },
    },
    isSelectRoom: {
      type: Boolean,
      default() {
        return false;
      },
    },
    selectRoomArr: {
      type: Array,
      default() {
        return [];
      },
    },
    submit: {
      type: Function,
    },
  },
  data() {
    return {
      payType: 0, //0默认 1会员卡 2挂账
      payItems: [], //支付方式列表
      roomId: null,
      //支付的相关数据
      data: [
        {
          GuestId: 0,
          AccountItemId: "",
          Money: this.money,
          Quantity: 1,
          BillNo: "",
          // PlatformPayBillNo: "",
          // PlatformPayTradeNo: "",
          CustomerId: "0",
          TargetName: "",
          Remark: "",
          // OrderId: this.$route.query.id
        },
      ],
    };
  },
  model: {},
  created() {
    getSelectData({ Types: "payway" }).then(res => {
      this.payItems = res.Data.payway;
    });
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    //选择支付方式change
    changeItem(value) {
      if (value) {
        let item = this.payItems.find(p => p.Id == value.Id);
        if (item && item.Data && item.Data.Attributes) {
          if ((item.Data.Attributes & 4096) > 0) {
            this.payType = 1;
          } else if ((item.Data.Attributes & 2) > 0) {
            this.payType = 2;
          } else {
            this.payType = 0;
          }
        } else {
          this.payType = 0;
        }
        this.onSwitchItem(this.payType);
      } else {
        this.payType = 0;
        this.data[0].MemberCardId = 0;
        this.data[0].MemberCardNo = "";
        this.data[0].Password = "";
        this.data[0].TargetName = "";
        this.data[0].CustomerId = 0;
      }
    },
    onSwitchItem(value) {
      switch (value) {
        case 1: //会员卡
          this.onSelectMember();
          break;
        case 2: //挂账
          this.onSelectCustomer();
          break;
        default:
          //其他
          this.data[0].MemberCardId = 0;
          this.data[0].MemberCardNo = "";
          this.data[0].Password = "";
          this.data[0].TargetName = "";
          this.data[0].CustomerId = 0;
          break;
      }
    },
    //会员卡
    onSelectMember() {
      selectMember({
        height: "90%",
        change: info => {
          this.data[0].MemberCardId = info.Id;
          this.data[0].MemberCardNo = info.CardNo;
          this.data[0].Password = "";
          this.data[0].TargetName = info.Name;
        },
      });
    },
    //挂账
    onSelectCustomer() {
      selectUser({
        height: "90%",
        change: info => {
          this.data[0].CustomerId = info.Id;
          this.data[0].TargetName = info.Name;
        },
      });
    },
    onSubmit() {
      // if (!this.data[0].Money) {
      //   Notify("请填写金额");
      //   return false;
      // }
      // if (!this.data[0].AccountItemId) {
      //   Notify("请选择付款方式");
      //   return false;
      // }
      if (this.isSelectRoom) {
        this.data[0].RoomId = this.RoomId;
      }
      if (this.payType == 1) {
        if (Number(this.data[0].Money) != 0) {
          if (!this.data[0].MemberCardId) {
            Notify("请选择会员卡！");
            return false;
          }
          MemberPasswordVerify({
            MemberCardId: this.data[0].MemberCardId,
            money: this.data[0].Money,
            success: password => {
              console.log("success", password);
              this.$emit("submit", this.data);
            },
            error: () => {
              console.log("error");
            },
          });
        } else {
          this.$emit("submit", this.data);
        }
      } else {
        this.$emit("submit", this.data);
      }
    },
  },
};
</script>

<style scoped>
.submit {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  padding: 5px 16px;
  background-color: #fff;
}
</style>
